$(document).ready(function () {
    $('.mi-corpo-product-listing-product').hover(function () {
        $('#' + this.id).children('.mi-corpo-product-listing-product-link').toggleClass('mi-corpo-product-listing-product-link-hover');
    });

    $(window).resize(function () {
        // This will fire each time the window is resized:
        if ($(window).width() >= 1024) {
            $('#mi-corpo-crosssellingblocks-img').attr('height', '186');
            $('#mi-corpo-crosssellingblocks-img').attr('width', '190');


        }
 else {
            $('#mi-corpo-crosssellingblocks-img').attr('height', '100');
            $('#mi-corpo-crosssellingblocks-img').attr('width', '100');
        }
    }).resize(); // This will simulate a resize to trigger the initial run.
});
